export default {
	title: 'Autodiagnóstico del Terminal',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Datos de Autodiagnóstico del Terminal',
		description: 'No se encontraron datos de autodiagnóstico del terminal'
	},
	actions: {
		add: 'Agregar',
		diagnose: 'Diagnosticar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		diagnosisSuccess: 'Diagnóstico completado',
		missingTerminalId: 'Falta el ID del terminal; no se puede iniciar el diagnóstico',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		projNo: 'Proyecto',
		typeId: 'Tipo de Terminal',
		maker: 'Fabricante',
		transferProtocol: 'Protocolo de Comunicación',
		model: 'Modelo',
		number: 'Número del Terminal',
		upMode: 'Modo de Subida',
		downMode: 'Modo de Bajada',
		placeholder: {
			projNo: 'Por favor seleccione proyecto',
			typeId: 'Por favor seleccione tipo de terminal',
			maker: 'Por favor ingrese el fabricante',
			transferProtocol: 'Por favor seleccione protocolo de comunicación',
			model: 'Por favor ingrese el modelo',
			number: 'Por favor ingrese el número del terminal',
			upMode: 'Por favor seleccione modo de subida',
			downMode: 'Por favor seleccione modo de bajada'
		}
	},
	table: {
		number: 'Número del Terminal',
		projNo: 'N° de Proyecto',
		model: 'Modelo',
		downMode: 'Modo de Bajada',
		pingTime: 'Tiempo de Ping',
		typeId: 'Tipo de Terminal',
		transferProtocol: 'Protocolo de Comunicación',
		remark: 'Observación',
		warnStatus: 'Estado del Terminal',
		notDetected: 'No detectado',
		noConnection: 'No se puede establecer conexión',
		maker: 'Fabricante'
	},
	detail: {
		normal: 'Normal',
		abnormal: 'Anormal',
		sdram: 'SDRAM',
		rtc: 'RTC',
		flash: 'Flash',
		uart: 'UART',
		exflash: 'Flash Externa',
		sensor: 'Estado del Sensor',
		connected: 'Conectado',
		disconnected: 'Desconectado'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		close: 'Cerrar',
		selfDiagnosisDetail: 'Detalles del Autodiagnóstico'
	}
}
